import { StatsCount, Message } from 'types/global'

/**
 * Interface padrão
 */
export interface ISector {
    sys_id?: string
    u_name: string
    u_count_inactive?: string
    u_active?: string
    u_count_active?: string
    u_location?: string
}
/**
 * Interface para redux action
 */
export interface ISectorAction {
    type: string
    payload: any
}
/**
 * Interface para objeto reducer
 */
export interface ISectorReducer {
    sector: Sector
    sectorsList: SectorList
    sectorAllCount?: number
    sectorWithNotificationCount?: number
    sectorsGroupedByLocationId: {
        [key: string]: {
            sys_id: string
            u_name: string
        }[]
    }
    sectorsListDataTable: any[][]
    sectorsListNames: string[]
    loading: boolean
    loadingCount: boolean
    loadingReportCount: boolean
    error: boolean
    message: Message
}
/**
 * Interface usada no Axios para retorno lista de setores paginado
 */
export interface IResultSectorGetAllPaginate {
    result: SectorList
    stats: any
}
/**
 * Interface usada no Axios para retorno da contagem de setores
 */
export interface IResultSectorGetCount {
    result: SectorStatsCount
}
/**
 * Interface usada no Axios para retorno de setor por id
 */
export interface IResultSectorGetById {
    result: Sector[]
}
/**
 * Tipo para redux action
 */
export type SectorAction = ISectorAction
/**
 * Tipo para lista padrão
 */
export type SectorList = ISector[]
/**
 * Tipo para reducer
 */
export type SectorReducer = ISectorReducer
/**
 * Tipo padrão para setor
 */
export type Sector = ISector
/**
 * Tipo padrão para retorno de contagem
 */
export type SectorStatsCount = StatsCount
/**
 * Objeto padrão
 */
export const SectorReducerTypeInitiator: ISectorReducer = {
    sector: <Sector>{},
    sectorsList: [],
    sectorsGroupedByLocationId: {},
    sectorsListDataTable: [],
    sectorsListNames: [],
    loading: true,
    loadingCount: false,
    loadingReportCount: false,
    error: false,
    sectorAllCount: 0,
    message: { visible: false, status: null, text: null } as Message
}

/**
 * Objeto padrão
 */
export const SectorTypeInitiator: Sector = {
    sys_id: '',
    u_name: '',
    u_count_inactive: '',
    u_active: '',
    u_count_active: ''
}
/**
 * Tipo usado no Axios para retorno lista de setores paginado
 */
export type ResultSectorGetAllPaginate = IResultSectorGetAllPaginate
/**
 * Tipo usado no Axios para retorno da contagem de setores
 */
export type ResultSectorGetCount = IResultSectorGetCount
/**
 * Tipo usado no Axios para retorno de setor por id
 */
export type ResultSectorGetById = IResultSectorGetById
